class PriceRangeSlider extends HTMLElement {
  connectedCallback() {
    this.minInput = this.querySelector("[data-range-min]");
    this.maxInput = this.querySelector("[data-range-max]");
    this.fill = this.querySelector("[data-range-fill]");
    this.minDisplay = this.querySelector("[data-price-min-display]");
    this.maxDisplay = this.querySelector("[data-price-max-display]");
    if (!this.minInput || !this.maxInput) return;
    this.minInput.addEventListener("input", this.onMinChange.bind(this));
    this.maxInput.addEventListener("input", this.onMaxChange.bind(this));
    this.updateFill();
  }
  onMinChange() {
    const min = parseInt(this.minInput.value, 10);
    const max = parseInt(this.maxInput.value, 10);
    if (min > max) {
      this.minInput.value = max;
    }
    this.updateFill();
    this.updateDisplay();
  }
  onMaxChange() {
    const min = parseInt(this.minInput.value, 10);
    const max = parseInt(this.maxInput.value, 10);
    if (max < min) {
      this.maxInput.value = min;
    }
    this.updateFill();
    this.updateDisplay();
  }
  updateFill() {
    const rangeMax = parseInt(this.maxInput.max, 10);
    const min = parseInt(this.minInput.value, 10);
    const max = parseInt(this.maxInput.value, 10);
    const left = min / rangeMax * 100;
    const right = 100 - max / rangeMax * 100;
    this.fill.style.left = `${left}%`;
    this.fill.style.right = `${right}%`;
  }
  updateDisplay() {
    if (this.minDisplay) {
      this.minDisplay.textContent = `€${parseInt(this.minInput.value, 10)}`;
    }
    if (this.maxDisplay) {
      this.maxDisplay.textContent = `€${parseInt(this.maxInput.value, 10)}`;
    }
  }
}
customElements.define("price-range-slider", PriceRangeSlider);
